import { Menu, PanelLeftClose } from 'lucide-react'
import { useAuth } from '@/features/auth/AuthContext'
import { Button } from '@/components/ui/button'
import { ThemeToggle } from '@/components/ThemeToggle'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { NotificationBell } from '@/features/notifications/components/NotificationBell'
import { UserMenu } from './UserMenu'

interface AppHeaderProps {
  sidebarOpen: boolean
  onToggleSidebar: () => void
  onOpenMobileSidebar: () => void
}

export function AppHeader({ sidebarOpen, onToggleSidebar, onOpenMobileSidebar }: AppHeaderProps) {
  const { currentTenant } = useAuth()

  return (
    <header className="border-b bg-card h-16 flex items-center justify-between px-4">
      <div className="flex items-center gap-3">
        {/* Mobile menu button */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={onOpenMobileSidebar}
        >
          <Menu className="h-5 w-5" />
        </Button>

        {/* Desktop sidebar toggle */}
        <Button
          variant="ghost"
          size="icon"
          className="hidden md:inline-flex"
          onClick={onToggleSidebar}
        >
          <PanelLeftClose className={`h-5 w-5 transition-transform ${!sidebarOpen ? 'rotate-180' : ''}`} />
        </Button>

        {/* Tenant info */}
        {currentTenant && (
          <div className="flex items-center gap-2">
            {currentTenant.tenant.logo_url && (
              <img
                src={currentTenant.tenant.logo_url}
                alt={currentTenant.tenant.name}
                className="h-8 w-8 rounded object-contain"
              />
            )}
            <span className="font-medium text-sm hidden sm:inline">
              {currentTenant.tenant.name}
            </span>
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        <NotificationBell />
        <ThemeToggle />
        <LanguageSwitcher />
        <UserMenu />
      </div>
    </header>
  )
}
